import { validate } from "@material-ui/pickers";
import api from "../../config/http-common";

const getAllVisitorDocuments = (payload) => {
  return api
    .securedAxios()
    .get("/web/api/v4/visitors/" + payload.rowData.id + "/documents");
};

const uploadVisitorAsset = (payload) => {
  return api.unsecuredAxios().post("/web/api/v4/visitor/document", payload);
};

const deteleAssetImage = (payload) => {
  return api.unsecuredAxios().post("/web/api/v4/visitor/documents", payload);
};

const validateVisitorImage = (payload) => {
  return api.unsecuredAxios().post("/web/visit/validate-photo", payload);
};

const visitorDocumentService = {
  getAllVisitorDocuments,
  uploadVisitorAsset,
  deteleAssetImage,
  validateVisitorImage,
};

export default visitorDocumentService;
